let algoliasearch = null;
if (__NATIVE__) {
  algoliasearch = require('algoliasearch/reactnative');
} else {
  algoliasearch = require('algoliasearch');
}
export function fetchObject({
  objectID,
  attributesToRetrieve,
  searchIndex,
  appName,
  apiKey
}) {
  const algolia = algoliasearch(appName, apiKey, {
    timeouts: {
      connect: 3000,
      read: 5000,
      write: 30000
    }
  });
  const index = algolia.initIndex(searchIndex);
  if (attributesToRetrieve) {
    return index.getObject(objectID, attributesToRetrieve);
  }
  return index.getObject(objectID);
}
export function fetchObjects({
  objectIDs,
  attributesToRetrieve = ['*'],
  searchIndex,
  appName,
  apiKey,
  callback
}) {
  const algolia = algoliasearch(appName, apiKey, {
    timeouts: {
      connect: 3000,
      read: 5000,
      write: 30000
    }
  });
  const index = algolia.initIndex(searchIndex);
  return index.getObjects(objectIDs, attributesToRetrieve, callback);
}